import React from "react";
// react plugin used to create a form with multiple steps
// import ReactWizard from "react-bootstrap-wizard";

// reactstrap components
import { Col } from "reactstrap";

import { handleClientCSVRequest, handlePaymentCSVRequest, handleUnitCSVRequest } from "../../api/import";

// wizard steps
// import Step1 from "./WizardSteps/Step1.js";
// import Step2 from "./WizardSteps/Step2.js";
// import Step3 from "./WizardSteps/Step3.js";

class Imports extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      importType: null,
      isImportCompleted: false,
      clientBulkResult: null,
      clientBulkSucess: false,
      clientBulkLoading: false,
      clientBulkReady: false,
      paymentBulkResult: null,
      paymentBulkSucess: false,
      paymentBulkLoading: false,
      paymentBulkReady: false,
      unitBulkResult: null,
      unitBulkSucess: false,
      unitBulkLoading: false,
      unitBulkReady: false,
      inputArray: null
    };
  }

  onChangeImportType = (importType) => {
    this.setState({ importType: importType.value });
  }

  onDataUploaded = (input) => {
    console.log('input', JSON.stringify(input))
    this.setState({inputArray: input})
    const { importType } = this.state;
    switch(importType) {
      case "clients":
        this.setState({clientBulkReady: true})
      break;
      case "payments":
        this.setState({paymentBulkReady: true})
      break;
      case "units":
        this.setState({unitBulkReady: true})
      break;
      default:
      break;
    }
  }

  onFinishImport = async () => {
    const { importType, inputArray } = this.state;
    switch(importType) {
      case 'clients': 
        try {
          this.setState({
            clientBulkLoading: true
          })
          
          const result = await handleClientCSVRequest(inputArray);

          this.setState({
            clientBulkResult: result,
            clientBulkSuccess: true,
            clientBulkLoading: false
          })
          
        } catch(err) {
          console.log(err);
          this.setState({  
            clientBulkResult: null,
            clientBulkSucess: false,
            clientBulkLoading: false
          })
        }
        break;
      case 'payments': 
        try {
          this.setState({
            paymentBulkLoading: true
          })

          const result = await handlePaymentCSVRequest(inputArray);

          this.setState({
            paymentBulkResult: result,
            paymentBulkSuccess: true,
            paymentBulkLoading: false
          })
          
        } catch(err) {
          console.log(err);
          this.setState({  
            paymentBulkResult: null,
            paymentBulkSucess: false,
            paymentBulkLoading: false
          })
        }
        break;
      case 'units': 
        try {
          this.setState({
            unitBulkLoading: true
          })

          const result = await handleUnitCSVRequest(inputArray);

          this.setState({
            unitBulkResult: result,
            unitBulkSuccess: true,
            unitBulkLoading: false
          })
          
        } catch(err) {
          console.log(err);
          this.setState({  
            unitBulkResult: null,
            unitBulkSucess: false,
            unitBulkLoading: false
          })
        }
        break;
      default: break;
    }
  }

  render() {
    // Remove unused variables from destructuring
    const { isImportCompleted } = this.state;

    return (
      <>
        <div className="content">
          <Col className="mr-auto ml-auto" md="10">
            {!isImportCompleted ? {/*<ReactWizard
              steps={steps}
              navSteps
              validate
              title="Importing data"
              description="Select import type and follow the steps."
              headerTextCenter
              finishButtonClasses="btn-wd btn-info"
              nextButtonClasses="btn-wd btn-info"
              previousButtonClasses="btn-wd"
              progressbar
              color="blue"
              finishButtonClick={this.onFinishImport}
            />*/} : <div>
              <h3 className="card-title">Import has been completed successfully.</h3>
              <button onClick={() => this.setState({ isImportCompleted: false })} className="btn btn-wd text-center btn-info">Import Another File</button>
            </div>}
          </Col>
        </div>
      </>
    );
  }
}

export default Imports;
